<template>
  <div class="d-print-none">
    <b-container fluid class="height-nav text-center">
      <b-row class="">
        <b-col lg="6">
          <div class="">
            <div class="pt-2 col-md-12 col-sm-12" id="st-1">
              <a
                  target="_blank"
                  :href="`https://wa.me/${findAttributeOnSiteInfo(
                  'social_media_whatsapp'
                )}`"
              >
                <div
                    class="st-btn"
                    data-network="whatsapp"
                    v-if="findAttributeOnSiteInfo('social_media_whatsapp')"
                >
                  <svg
                      class=""
                      xmlns="http://www.w3.org/2000/svg"
                      color="black"
                      width="24"
                      height="24"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                  >
                    <path
                        d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                    />
                  </svg>
                </div>
              </a>

              <a
                  target="_blank"
                  :href="findAttributeOnSiteInfo('social_media_twitter')"
              >
                <div
                    class="st-btn "
                    data-network="twitter"
                    v-if="findAttributeOnSiteInfo('social_media_twitter')"
                >
                  <b-icon
                      icon="twitter"
                      class="h3  text-dark"
                      href="#"
                  ></b-icon>
                </div>
              </a>

              <a
                  target="_blank"
                  :href="findAttributeOnSiteInfo('social_media_telegram')"
              >
                <div
                    class="st-btn"
                    data-network="telegram"
                    v-if="findAttributeOnSiteInfo('social_media_telegram')"
                >
                  <svg
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24px"
                      height="24px"
                  >
                    <path
                        d="M 20.572266 3.0117188 C 20.239891 2.9764687 19.878625 3.028375 19.515625 3.171875 C 19.065625 3.348875 12.014406 6.3150313 5.4414062 9.0820312 L 3.2695312 9.9960938 C 2.4285313 10.337094 2.0039062 10.891672 2.0039062 11.638672 C 2.0039062 12.161672 2.22525 12.871063 3.28125 13.289062 L 6.9472656 14.757812 C 7.2642656 15.708813 8.0005469 17.916906 8.1855469 18.503906 C 8.2955469 18.851906 8.5733906 19.728594 9.2753906 19.933594 C 9.4193906 19.982594 9.5696563 20.007813 9.7226562 20.007812 C 10.165656 20.007812 10.484625 19.801641 10.640625 19.681641 L 12.970703 17.710938 L 15.800781 20.328125 C 15.909781 20.439125 16.486719 21 17.261719 21 C 18.228719 21 18.962234 20.195016 19.115234 19.416016 C 19.198234 18.989016 21.927734 5.2870625 21.927734 5.2890625 C 22.172734 4.1900625 21.732219 3.6199531 21.449219 3.3769531 C 21.206719 3.1694531 20.904641 3.0469688 20.572266 3.0117188 z M 19.910156 5.171875 C 19.533156 7.061875 17.478016 17.378234 17.166016 18.865234 L 13.029297 15.039062 L 10.222656 17.416016 L 11 14.375 C 11 14.375 16.362547 8.9468594 16.685547 8.6308594 C 16.945547 8.3778594 17 8.2891719 17 8.2011719 C 17 8.0841719 16.939781 8 16.800781 8 C 16.675781 8 16.506016 8.1197812 16.416016 8.1757812 C 15.272669 8.8885973 10.404094 11.662239 8.0078125 13.025391 L 4.53125 11.636719 L 6.21875 10.927734 C 10.51775 9.1177344 18.174156 5.893875 19.910156 5.171875 z"
                    />
                  </svg>
                </div>
              </a>

              <a
                  target="_blank"
                  :href="findAttributeOnSiteInfo('social_media_instagram')"
              >
                <div
                    class="st-btn"
                    data-network="instagram"
                    v-if="findAttributeOnSiteInfo('social_media_instagram')"
                >
                  <svg
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24px"
                      height="24px"
                  >
                    <path
                        d="M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z"
                    />
                  </svg>
                </div>
              </a>

              <a
                  target="_blank"
                  :href="findAttributeOnSiteInfo('social_media_linkedin')"
              >
                <div
                    class="st-btn"
                    data-network="linkedin"
                    v-if="findAttributeOnSiteInfo('social_media_linkedin')"
                >
                  <svg
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 30 30"
                      width="30px"
                      height="30px"
                  >
                    <path
                        d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M10.496,8.403 c0.842,0,1.403,0.561,1.403,1.309c0,0.748-0.561,1.309-1.496,1.309C9.561,11.022,9,10.46,9,9.712C9,8.964,9.561,8.403,10.496,8.403z M12,20H9v-8h3V20z M22,20h-2.824v-4.372c0-1.209-0.753-1.488-1.035-1.488s-1.224,0.186-1.224,1.488c0,0.186,0,4.372,0,4.372H14v-8 h2.918v1.116C17.294,12.465,18.047,12,19.459,12C20.871,12,22,13.116,22,15.628V20z"
                    />
                  </svg>
                </div>
              </a>

              <a
                  target="_blank"
                  :href="findAttributeOnSiteInfo('social_media_youtube')"
              >
                <div
                    class="st-btn"
                    data-network="youtube"
                    v-if="findAttributeOnSiteInfo('social_media_youtube')"
                >
                  <b-icon
                      icon="youtube"
                      class="h3  text-danger"
                      href="#"
                  ></b-icon>
                </div>
              </a>

              <a
                  target="_blank"
                  :href="findAttributeOnSiteInfo('social_media_pinterest')"
              >
                <div
                    class="st-btn"
                    data-network="pinterest"
                    v-if="findAttributeOnSiteInfo('social_media_pinterest')"
                >
                  <svg
                      class=""
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24px"
                      height="24px"
                  >
                    <path
                        d="M 12 2 C 6.477 2 2 6.477 2 12 C 2 17.523 6.477 22 12 22 C 17.523 22 22 17.523 22 12 C 22 6.477 17.523 2 12 2 z M 12 4 C 16.418 4 20 7.582 20 12 C 20 16.418 16.418 20 12 20 C 11.264382 20 10.555494 19.892969 9.8789062 19.707031 C 10.09172 19.278284 10.282622 18.826454 10.386719 18.425781 C 10.501719 17.985781 10.972656 16.191406 10.972656 16.191406 C 11.278656 16.775406 12.173 17.271484 13.125 17.271484 C 15.958 17.271484 18 14.665734 18 11.427734 C 18 8.3227344 15.467031 6 12.207031 6 C 8.1520313 6 6 8.7215469 6 11.685547 C 6 13.063547 6.73325 14.779172 7.90625 15.326172 C 8.08425 15.409172 8.1797031 15.373172 8.2207031 15.201172 C 8.2527031 15.070172 8.4114219 14.431766 8.4824219 14.134766 C 8.5054219 14.040766 8.4949687 13.958234 8.4179688 13.865234 C 8.0299688 13.394234 7.71875 12.529656 7.71875 11.722656 C 7.71875 9.6496562 9.2879375 7.6445312 11.960938 7.6445312 C 14.268937 7.6445313 15.884766 9.2177969 15.884766 11.466797 C 15.884766 14.007797 14.601641 15.767578 12.931641 15.767578 C 12.009641 15.767578 11.317063 15.006312 11.539062 14.070312 C 11.804063 12.953313 12.318359 11.747406 12.318359 10.941406 C 12.318359 10.220406 11.932859 9.6191406 11.130859 9.6191406 C 10.187859 9.6191406 9.4296875 10.593391 9.4296875 11.900391 C 9.4296875 12.732391 9.7109375 13.294922 9.7109375 13.294922 C 9.7109375 13.294922 8.780375 17.231844 8.609375 17.964844 C 8.5246263 18.326587 8.4963381 18.755144 8.4941406 19.183594 C 5.8357722 17.883113 4 15.15864 4 12 C 4 7.582 7.582 4 12 4 z"
                    />
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </b-col>
        <b-col lg="6">
          <div class="mt-lg-2 mb-md-3 mb-sm-3 ">
              <span class="text " v-if="findAttributeOnSiteInfo('cell_phone')">
                <a class=" px-1 m-2 text-decoration-none text-dark" dir="ltr"
                   v-for=" (cell_phone ,index) in findAttributeOnSiteInfo('cell_phone')" :key="index"
                   :href="`tel:${cell_phone}`"> {{ cell_phone }}</a>
              </span>

            <span class="text " v-if="findAttributeOnSiteInfo('tel_phone')">
                <a class=" px-1 m-2 text-decoration-none text-dark" dir="ltr"
                   v-for="(tel_phone ,index) in findAttributeOnSiteInfo('tel_phone')" :key="index"
                   :href="`tel:${tel_phone}`"> {{ tel_phone }}</a>
              </span>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "Nav4",
  computed: {},
};
</script>

<style scoped>
.height-nav {
  background-color: var(--light-indigo) !important;
  color: var(--light);
  width: 100%;
  min-height: 40px;
}

#st-1 .st-btn {
  border: none;
  display: inline-block;
  font-size: 10px;
  height: 20px;
  line-height: 20px;
  margin-right: 10px;
  color: var(--dark);
  position: relative;
  text-align: center;
  vertical-align: top;
}

.m {
  margin: 1rem;
}

.border-right-nav {
  border-right: 1px solid var(--light);

}

.text-decoration-none {
  text-decoration: none !important;
}
</style>